'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InfoLabel", {
    enumerable: true,
    get: function() {
        return InfoLabel;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _renderInfoLabel = require("./renderInfoLabel");
const _useInfoLabel = require("./useInfoLabel");
const _useInfoLabelStylesstyles = require("./useInfoLabelStyles.styles");
const InfoLabel = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useInfoLabel.useInfoLabel_unstable)(props, ref);
    (0, _useInfoLabelStylesstyles.useInfoLabelStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useInfoLabelStyles_unstable')(state);
    return (0, _renderInfoLabel.renderInfoLabel_unstable)(state);
});
InfoLabel.displayName = 'InfoLabel';
